<template>
  <div
    class="work-card"
    @click="goWorkDetail"
    :class="[isDialog ? 'dialog' : false, $platformClass]"
  >
    <Title class="text-xl" type="articleTtile">{{ work.SUBJECT }}</Title>
    <p class="text work-card-user">
      <span>{{ work.GAME_SERVER_NAME }}</span>
      -
      <span>{{ work.CHARACTER_NAME }}</span>
    </p>
    <p class="text work-card-message">{{ work.MESSAGE }}</p>
    <p class="text work-card-time">{{ formatedCreateTime }}</p>
    <i class="work-card-dot" v-if="visibleRedDot"></i>
  </div>
</template>
<script>
import formatDate from '../../utiles/formatDate.js';
export default {
  name: 'work-card',
  computed: {
    formatedCreateTime: function () {
      let date = new Date(this.work.CREATE_TIME * 1000);
      let time = formatDate(date, 'MM/dd/yyyy');
      return time;
    },
    isDialog: function () {
      return this.dialog || false;
    },
    visibleRedDot() {
      return this.work?.UNREAD_COUNT > 0;
    }
  },
  methods: {
    goWorkDetail: function () {
      this.$emit('go-detail', this.index);
    }
  },
  props: ['work', 'index', 'dialog']
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.work-card {
  width: 100%;
  height: 368px;
  margin-top: 30px;
  border: solid 1px #dfdfdf;
  padding: 32px;
  position: relative;
  .text-xl {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-user {
    line-height: 60px;
  }
  &-message {
    width: 100%;
    height: 150px;
    line-height: 37.5px;
    overflow: hidden;
    border-bottom: solid 1px #dfdfdf;
    @include cut-text(4);
  }
  &-time {
    height: 60px;
    line-height: 60px;
    position: absolute;
    bottom: 0;
  }
  &-dot {
    @include size(12, 12);
    display: inline-block;
    @include bgPng('dot');
    position: absolute;
    top: 10px;
    right: 10px;
  }
  &:last-of-type {
    margin-bottom: 30px;
  }
}
</style>
